import axios from 'axios'
axios.create({
  timeout: 60000
});
export default function ajax (url:any, data:any={}, type:string='GET') {
    return new Promise((resolve, reject) => {
      if(type == 'GET'){
        axios.get(url, {
          data
        })
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err: any) => {
          reject(err);
        });
      }else{
        axios({
        method: 'post',
        url,
        params: data,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      }).then((res:any) => {
        resolve(res.data);
      }).catch((err:any) => {
        console.error(err, 'error')
      })
      }
      
    })
}
